import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
const StyledContainer = styled.div `
  max-width: ${({ extraWide }) => extraWide ? pxToRems(1400) : pxToRems(1200)};
  margin: 0 auto;
`;
/**
 * A component for rendering content inside a container with a consistent maximum page width of 1200px.
 *
 * Child elements passed to the container will be rendered inside a `div` by default, unless a preferred element is supplied via the `as` prop.
 */
export const Container = ({ as = 'div', extraWide = false, children, ...rest }) => {
    return (_jsx(StyledContainer, { as: as, extraWide: extraWide, ...rest, children: children }));
};
//# sourceMappingURL=container.js.map